const SvgYes = (props) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 16.5H3.25C2.85218 16.5 2.47064 16.342 2.18934 16.0607C1.90804 15.7794 1.75 15.3978 1.75 15V9.75C1.75 9.35218 1.90804 8.97064 2.18934 8.68934C2.47064 8.40804 2.85218 8.25 3.25 8.25H5.5M10.75 6.75V3.75C10.75 3.15326 10.5129 2.58097 10.091 2.15901C9.66903 1.73705 9.09674 1.5 8.5 1.5L5.5 8.25V16.5H13.96C14.3217 16.5041 14.6728 16.3773 14.9484 16.143C15.2241 15.9087 15.4058 15.5827 15.46 15.225L16.495 8.475C16.5276 8.26002 16.5131 8.04051 16.4525 7.83169C16.3919 7.62287 16.2866 7.42972 16.1439 7.26564C16.0012 7.10155 15.8246 6.97045 15.6262 6.88141C15.4278 6.79238 15.2124 6.74754 14.995 6.75H10.75Z"
      style={{ fill: 'var(--kula-colors-white, #FFFFFF)' }}
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgYes;
